import styles from './Dropdown.module.scss';
import React, { HTMLAttributes, PropsWithChildren } from 'react';
import cls from 'classnames';

const noop = () => {};

export const AnchorVerification = React.createContext<typeof noop>(() => {
  throw Error(
    `Dropdown element is missing a DropdownAnchor parent. Dropdowns require a DropdownAnchor element as a parent to know where to render.`,
  );
});

export function DropdownAnchor({
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    // DropdownAnchor parents replace the verification provider with a function that does nothing
    <AnchorVerification.Provider value={noop}>
      <div className={cls(styles.dropdownAnchor, rest.className)} {...rest}>
        {children}
      </div>
    </AnchorVerification.Provider>
  );
}
